<template>
  <v-app>
    <v-main>
      <v-scroll-x-transition :hide-on-leave="true">
        <router-view />
      </v-scroll-x-transition>
    </v-main>
  </v-app>
</template>

<script>
export default {
  name: "App",

  data() {
    return {};
  },
  computed: {
    userLoaded() {
      return this.$store.getters.userLoaded;
    },
  },
  created() {
    if (localStorage.getItem("access_token")) {
      this.$store
        .dispatch("getUserdata")
        .then(() => {})
        .catch(() => {
          this.$router.push({ name: "home" });
          alert("App loading API failed");
        });
    }
  },
};
</script>

<style>
body {
  background-color: #1e242e;
}
</style>
